module.exports = __webpack_public_path__ + "static/media/engineFill.cbc70f7a.svg";